export default defineNuxtPlugin(() => {
  // 初始化sdk
  if (process.client) {
    const { $i18n: { localeProperties } } = useNuxtApp()
    const { public: { userAppId, appId } } = useRuntimeConfig()
    const route = useRoute()
    watch(localeProperties, async (properties) => {
      const { code } = properties
      const initConfig = {
        code: route.query.state,
        appId: `${userAppId}`,
        region: 'oversea' as const,
        // TODO：中台暂时不支持意大利语（it），默认先主动传it，支持了再去掉。
        languageCode: getBCP47byLanguageCode(code) || 'it',
        develop: isTest(),
        extAppId: appId,
        payApiUrl: 'https://sg-pay.ldshop.gg',
        userApiUrl: isTest() ? '' : 'https://sg-user.ldshop.gg',
        robotCheck: true,
      }
      initLdSdk(initConfig as any)
    }, { immediate: true })
  }
})
